<template>
  <div>
    <tsp-summary-chart :value="filter === 'future' ? futureTspSummary : todaysTspSummary" />
    <p>
      This chart summarizes your TSP account based on the information you provided.
    </p>
    <tsp-summary-table :value="filter === 'future' ? futureTspSummary : todaysTspSummary" />
    <div>
      <more-info :moreInfo="moreInfo.tspSummary" @click="moreInfoOpen" />
    </div>
  </div>
</template>

<script>
import TspSummaryMixin from '@/js/mixins/calculator/results/tsp-summary/tsp-summary-mixin';

export default {
  mixins: [
    TspSummaryMixin,
  ],
};
</script>
